import { ExtraPricesStory } from '@aclass/admin/storage/actions';
import { IExtraPricesModuleState, INITIAL_EXTRA_PRICES_STATE } from '@aclass/admin/storage/states';
import { Action } from '@aclass/core/storage/action';
import { TypedState } from '@aclass/core/storage/states/module.state';
import { fromJS, List, Map } from 'immutable';

export const extraPricesModuleReducer = (state: TypedState<IExtraPricesModuleState> = INITIAL_EXTRA_PRICES_STATE, action: Action) => {
    const { type, payload } = action;
    switch (type) {
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_INIT_STATE:
            return state.update('searchPageInitialized', () => payload);
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_COLLAPSED:
            return state.update('searchPageCollapsed', () => payload);
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_SEARCH_LOCK:
            return state.update('searchPageLock', () => payload);
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_PAGINATION:
            return state.update('searchPagePagination', () => Map(payload));
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_ORDER:
            return state.update('searchPageOrder', () => Map(payload));
        case ExtraPricesStory.SEARCH_PAGE_IMPORT_RECORDS:
            return state.update('searchPageResults', () => List(payload));
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_DESTINATIONS:
            return state.update('searchPageDestinations', () => List(payload));
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_TOURS:
            return state.update('searchPageTours', () => List(payload));
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_COMBINATIONS:
            return state.update('searchPageCombinations', () => List(payload));
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_FILTER_DESTINATIONS:
            return state.update('searchPageFilterDestinations', () => List(payload));
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_FILTER_TOURS:
            return state.update('searchPageFilterTours', () => List(payload));
        case ExtraPricesStory.SEARCH_PAGE_UPDATE_FILTER_COMBINATIONS:
            return state.update('searchPageFilterCombinations', () => List(payload));
        case ExtraPricesStory.CREATE_PAGE_UPDATE_DESTINATIONS:
            return state.update('createPageDestinations', () => List(payload));
        case ExtraPricesStory.CREATE_PAGE_UPDATE_TOURS:
            return state.update('createPageTours', () => List(payload));
        case ExtraPricesStory.CREATE_PAGE_UPDATE_COMBINATIONS:
            return state.update('createPageCombinations', () => List(payload));
        case ExtraPricesStory.CREATE_PAGE_UPDATE_FORM:
            return state.update('createPageForm', () => fromJS(payload));
        case ExtraPricesStory.EDIT_PAGE_UPDATE_DESTINATIONS:
            return state.update('editPageDestinations', () => List(payload));
        case ExtraPricesStory.EDIT_PAGE_UPDATE_TOURS:
            return state.update('editPageTours', () => List(payload));
        case ExtraPricesStory.EDIT_PAGE_UPDATE_COMBINATIONS:
            return state.update('editPageCombinations', () => List(payload));
        case ExtraPricesStory.CREATE_PAGE_UPDATE_SAVE_LOCK:
            return state.update('createPageSaveLock', () => payload);
        case ExtraPricesStory.CREATE_PAGE_IMPORT_TOURS:
            return state.update('createPageToursIds', () => List(payload));
        case ExtraPricesStory.CREATE_PAGE_IMPORT_DESTINATIONS:
            return state.update('createPageDestinationsIds', () => List(payload));
        case ExtraPricesStory.CREATE_PAGE_IMPORT_COMBINATIONS:
            return state.update('createPageCombinationsIds', () => List(payload));
        case ExtraPricesStory.CREATE_PAGE_IMPORT_DESTINATIONS_MAPPINGS:
            return state.update('createPageDestinationsMappings', () => fromJS(payload));
        case ExtraPricesStory.CREATE_PAGE_IMPORT_COMBINATIONS_MAPPINGS:
            return state.update('createPageCombinationsMappings', () => fromJS(payload));
        case ExtraPricesStory.CREATE_PAGE_UPDATE_SEARCH_LOCK:
            return state.update('createPageSearchLock', () => payload);
        case ExtraPricesStory.EDIT_PAGE_UPDATE_EXTRA_PRICES_ID:
            return state.update('editPageRecordId', () => payload);
        case ExtraPricesStory.EDIT_PAGE_UPDATE_FORM_VALUE:
            return state.update('editPageFormValue', () => fromJS(payload));
        case ExtraPricesStory.CREATE_PAGE_UPDATE_INIT_STATE:
            return state.update('createPageInitialized', () => payload);
        case ExtraPricesStory.CREATE_PAGE_UPDATE_FORM_VALUE:
            return state.update('createPageFormValue', () => fromJS(payload));
        case ExtraPricesStory.EDIT_PAGE_UPDATE_SAVE_LOCK:
            return state.update('editPageSaveLock', () => payload);
        case ExtraPricesStory.EDIT_PAGE_IMPORT_TOURS:
            return state.update('editPageToursIds', () => List(payload));
        case ExtraPricesStory.EDIT_PAGE_IMPORT_DESTINATIONS:
            return state.update('editPageDestinationsIds', () => List(payload));
        case ExtraPricesStory.EDIT_PAGE_IMPORT_COMBINATIONS:
            return state.update('editPageCombinationsIds', () => List(payload));
        case ExtraPricesStory.EDIT_PAGE_IMPORT_DESTINATIONS_MAPPINGS:
            return state.update('editPageDestinationsMappings', () => fromJS(payload));
        case ExtraPricesStory.EDIT_PAGE_IMPORT_COMBINATIONS_MAPPINGS:
            return state.update('editPageCombinationsMappings', () => fromJS(payload));
        case ExtraPricesStory.EDIT_PAGE_UPDATE_SEARCH_LOCK:
            return state.update('editPageSearchLock', () => payload);
        case ExtraPricesStory.EDIT_PAGE_UPDATE_SHOW_REMOVE_MODAL:
            return state.update('showRemoveModal', () => payload);
        case ExtraPricesStory.EDIT_PAGE_UPDATE_REMOVE_MODAL_LOCK:
            return state.update('removeModalLock', () => payload);
        case ExtraPricesStory.EDIT_PAGE_UPDATE_FORM:
            return state.update('editPageForm', () => fromJS(payload));
        default:
            return state;
    }
};
